export default "__VITE_ASSET__CzrdAp$B__"